export default "__VITE_ASSET__BgON_EDf__"